import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import GuiaLogs from './GuiaLogs';

function GuiaLogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.GuiaLogsPage, [state.GuiaLogsPage]);

    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const Params = useParams();

    useEffect(() => {
        const getGuiaLogsCuantity = async () => {
            try {
                setLoader(true);

                const GuiaLogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 3,
                    objeto_id: parseInt(Params.id),
                });

                if (GuiaLogsCuantity) setTablePages(GuiaLogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getGuiaLogs = async () => {
            try {
                setLoader(true);

                const GuiaLogs = await LogService.byObject({
                    token,
                    objeto: 3,
                    objeto_id: parseInt(Params.id),
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (GuiaLogs) {
                    setTableData(buildTableData(GuiaLogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getGuiaLogsCuantity();
        getGuiaLogs();
    }, [tablePages, tablePage]);

    const buildTableData = (
        data = [{ fecha: '', hora: '', responsable: '', nivel: '', accion: 1 }]
    ) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            tableType: 'GuiaLogsPage',
            data: data?.map((log) => {
                return {
                    fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                    hora: dayjs(log.fecha).format('HH:mm:ss'),
                    responsable: log.apellido
                        ? `${log.apellido}, ${log.nombre}`
                        : 'ANÓNIMO',
                    nivel: log.tipo
                        ? masters.UserTypes?.find((m) => m.id === log.tipo)
                              ?.nombre
                        : 'ENLACE',
                    accion: masters.AccionTypes?.find(
                        (at) => at.id === log.accion
                    ).nombre.replace(/_/g, ' '),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <GuiaLogs tableData={tableData} />;
}

export default GuiaLogsContainer;
